<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="w-5 h-5 c-pointer primary--text"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="2"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 14a5 5 0 0 1 5 5v2H7v-2a5 5 0 0 1 5-5z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
    />
    <path stroke-linecap="round" stroke-linejoin="round" d="M19 8h4m-2-2v4" />
  </svg>
</template>
